import request from '@/utils/request'

// 获取打印模板列表
export const getPrintTemplates = (params) => {
  return request({
    url: '/api/print-templates',
    method: 'get',
    params
  })
}

// 获取单个打印模板
export const getPrintTemplate = (templateId) => {
  return request({
    url: `/api/print-templates/${templateId}`,
    method: 'get'
  })
}

// 创建打印模板
export const createPrintTemplate = (data) => {
  return request({
    url: '/api/print-templates',
    method: 'post',
    data
  })
}

// 更新打印模板
export const updatePrintTemplate = (templateId, data) => {
  return request({
    url: `/api/print-templates/${templateId}`,
    method: 'put',
    data
  })
}

// 复制打印模板（基于已有模板快速新建）
export const duplicatePrintTemplate = (templateId, data = {}) => {
  return request({
    url: `/api/print-templates/${templateId}/duplicate`,
    method: 'post',
    data
  })
}

// 删除打印模板
export const deletePrintTemplate = (templateId) => {
  return request({
    url: `/api/print-templates/${templateId}`,
    method: 'delete'
  })
}

// 设置默认模板
export const setDefaultTemplate = (templateId) => {
  return request({
    url: `/api/print-templates/${templateId}/set-default`,
    method: 'post'
  })
}

/** 包装资料：提交批次 JSON，返回模板 + print_data */
export const postPackingListPrintData = (payload) => {
  return request({
    url: '/api/print-data/packing-list',
    method: 'post',
    data: payload
  })
}

// 获取打印数据（第三参数可为模板 ID 或 { template_id, print_scenario }）
export const getPrintData = (templateType, recordId, templateIdOrOpts = null) => {
  const params = {}
  if (templateIdOrOpts != null && typeof templateIdOrOpts === 'object') {
    if (templateIdOrOpts.template_id != null) {
      params.template_id = templateIdOrOpts.template_id
    }
    if (templateIdOrOpts.print_scenario !== undefined && templateIdOrOpts.print_scenario !== null) {
      params.print_scenario = templateIdOrOpts.print_scenario
    }
    if (templateIdOrOpts.dispatch_order_item_id != null && templateIdOrOpts.dispatch_order_item_id !== '') {
      params.dispatch_order_item_id = templateIdOrOpts.dispatch_order_item_id
    }
    if (templateIdOrOpts.branch_record_id != null && templateIdOrOpts.branch_record_id !== '') {
      params.branch_record_id = templateIdOrOpts.branch_record_id
    }
  } else if (templateIdOrOpts != null) {
    params.template_id = templateIdOrOpts
  }
  return request({
    url: `/api/print-data/${templateType}/${recordId}`,
    method: 'get',
    params
  })
}

